// Green House · Landing "Ritual de Noche" (sección gh-ritual, v3): paquetes, precio, contador, galería y barra fija.
(function(){
  var root=document.getElementById('rn');if(!root)return;
  var C=JSON.parse(root.querySelector('[data-rn-config]').textContent);
  function money(n){return '$'+Math.round(n).toLocaleString('es-MX');}
  function $(s){return root.querySelector(s);}
  // Precio = suma - descuentos automáticos de Shopify: 3x2 en el softgel y Herbaldream a precio de kit con el softgel.
  // Probado en carrito el 22 oct 2026: 1 frasco $449 · softgel + jarabe $649 · 3 frascos $898.
  // Los descuentos terminan en "Fin real de la promoción": después se muestran los precios normales, como en el carrito.
  var end=C.deal_end?new Date(C.deal_end).getTime():0,live=!end||Date.now()<end;
  C.tiers.forEach(function(t){var hasVal=t.items.some(function(i){return i[0]==='val';});t.full=0;t.price=0;
    if(!live){t.free=null;if(t.key==='noventa'){t.name='3 frascos';t.cta='Quiero 3 frascos';t.badge=null;}}
    t.items.forEach(function(i){var pr=C.products[i[0]].price,line=pr*i[1],off=0;
      if(live&&i[0]==='val')off=Math.floor(i[1]/3)*pr;
      if(live&&i[0]==='her'&&hasVal)off=(pr-C.her_kit)*i[1];
      t.full+=line;t.price+=line-off;});
    t.sv=t.full-t.price;t.free_ship=t.price>=C.ship_free;});
  var maxSv=Math.max.apply(null,C.tiers.map(function(t){return t.sv;})),t3=C.tiers[C.tiers.length-1];

  // paquetes
  var fs=$('.tiers'),h='';
  C.tiers.forEach(function(t){
    var pills=(t.free?'<span class="v">'+t.free+'</span>':'')+(t.sv>0?'<span>Ahorras '+money(t.sv)+'</span>':'')+(t.free_ship?'<span>🚚 Envío gratis</span>':'<span class="g">+ envío '+money(C.ship_cost)+'</span>');
    h+='<label class="tier">'+(t.badge?'<span class="badge'+(t.gold?' g':'')+'">'+t.badge+'</span>':'')+'<input type="radio" name="pack" value="'+t.key+'"'+(t.key===C.default?' checked':'')+'>'+
      '<div class="t-row"><span class="rd"></span>'+(t.img?'<img class="t-img" src="'+t.img+'" alt="" loading="lazy" width="58" height="58">':'<span></span>')+'<span><span class="t-n">'+t.name+'</span><span class="t-s">'+t.sub+' · '+money(t.price/t.nights)+' por noche</span></span>'+
      '<span class="t-p"><b>'+money(t.price)+'</b>'+(t.sv>0?'<s>'+money(t.full)+'</s>':'')+'</span></div><div class="pills">'+pills+'</div></label>';});
  fs.insertAdjacentHTML('beforeend',h);
  if(!fs.querySelector('input:checked'))fs.querySelector('input').checked=true;

  var form=$('[data-form]'),buyable=!$('[data-add]').disabled;
  function cur(){var v=form.querySelector('input[name=pack]:checked').value;return C.tiers.filter(function(t){return t.key===v;})[0];}
  function line(t){return money(t.price)+(t.sv>0?' · Ahorras '+money(t.sv):'')+(t.free_ship?' · Envío gratis':' + envío');}
  function sync(){var t=cur();
    $('[data-save]').textContent=t.sv>0?'Ahorras '+money(t.sv):'Sin descuento';
    $('[data-bar]').style.width=Math.max(6,t.sv/maxSv*100)+'%';
    if(buyable){$('[data-cta-t]').textContent=t.cta+' →';$('[data-cta-s]').textContent=line(t);}
    $('[data-st-n]').textContent=t.name+' · '+money(t.price);$('[data-st-p]').textContent=(t.sv>0?'Ahorras '+money(t.sv)+' · ':'')+(t.free_ship?'Envío gratis':'+ envío '+money(C.ship_cost));}
  form.addEventListener('change',sync);sync();
  $('[data-night3]').textContent=money(t3.price/t3.nights);
  $('[data-final-s]').textContent=money(t3.price)+' en lugar de '+money(t3.full);
  $('[data-final-lead]').textContent='La opción más elegida: '+t3.nights+' noches, 1 frasco gratis, envío gratis y '+money(t3.price/t3.nights)+' por noche.';

  // contador hasta el fin real de la promoción (ajuste "Fin real de la promoción")
  var deal=$('[data-deal]'),fcd=$('[data-final-cd]');
  if(!live){['.stamp','.final','.mq'].forEach(function(q){var el=$(q);if(el)el.style.display='none';});}
  function pad(n){return String(n).padStart(2,'0');}
  function tick(){var ms=end-Date.now();if(!end||!(ms>0)){if(deal)deal.hidden=true;fcd.hidden=true;return false;}
    var d=Math.floor(ms/864e5),hh=Math.floor(ms/36e5)%24,mm=Math.floor(ms/6e4)%60,ss=Math.floor(ms/1e3)%60;
    if(deal){$('[data-d]').textContent=pad(d);$('[data-h]').textContent=pad(hh);$('[data-m]').textContent=pad(mm);$('[data-s]').textContent=pad(ss);}
    fcd.textContent='⏳ Termina en '+d+' días '+pad(hh)+':'+pad(mm)+':'+pad(ss);return true;}
  if(tick())setInterval(tick,1000);

  // entrega estimada: 3 a 5 días hábiles (tarifa estándar)
  function addBiz(n){var d=new Date();while(n>0){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)n--;}return d;}
  var f1=new Intl.DateTimeFormat('es-MX',{weekday:'short',day:'numeric'}),f2=new Intl.DateTimeFormat('es-MX',{weekday:'short',day:'numeric',month:'short'});
  $('[data-eta]').textContent=f1.format(addBiz(3))+' y '+f2.format(addBiz(5));

  // agrega los productos del paquete de una vez y va directo al pago
  function add(btn,t){if(!buyable)return;t=t||cur();btn.setAttribute('aria-busy','true');
    var items=t.items.map(function(i){return {id:C.products[i[0]].id,quantity:i[1]};});
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){if(!r.ok)throw r;location.href='/checkout';}).catch(function(){btn.removeAttribute('aria-busy');location.href='/cart';});}
  form.addEventListener('submit',function(e){e.preventDefault();add($('[data-add]'));});
  $('[data-st-add]').addEventListener('click',function(){add(this);});
  $('[data-final]').addEventListener('click',function(){add(this,t3);});

  // galería
  var track=$('[data-track]'),n=track.children.length,ix=0,dots=$('[data-dots]');
  for(var i=0;i<n;i++)dots.insertAdjacentHTML('beforeend','<button type="button" aria-label="Ver imagen '+(i+1)+'" aria-current="'+(i===0)+'"></button>');
  var db=[].slice.call(dots.children);
  function mark(){db.forEach(function(b,i){b.setAttribute('aria-current',String(i===ix));});}
  function go(i){ix=(i+n)%n;track.scrollTo({left:ix*track.clientWidth});mark();}
  track.addEventListener('scroll',function(){var i=Math.round(track.scrollLeft/track.clientWidth);if(i!==ix){ix=i;mark();}},{passive:true});
  db.forEach(function(b,i){b.addEventListener('click',function(){go(i);});});

  // encabezado según el anuncio (?v=)
  try{var k=new URLSearchParams(location.search).get('v'),heads=JSON.parse($('[data-rn-heads]').textContent||'{}');
    if(k&&heads[k])$('[data-headline]').innerHTML=heads[k];}catch(e){}

  // barra fija al pasar el botón de compra
  var sticky=$('[data-sticky]'),btn=$('[data-add]'),on=null;
  function onScroll(){var v=btn.getBoundingClientRect().bottom<0;if(v!==on){on=v;sticky.classList.toggle('on',v);sticky.setAttribute('aria-hidden',String(!v));$('[data-st-add]').tabIndex=v?0:-1;}}
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();
})();
